import { User } from "@app/common/types";

export const canAccessFeature = (
  user: Partial<User> | null,
  permissions?: { permission?: boolean; allowNoUser?: boolean }
): boolean => {
  if (!user) return permissions?.allowNoUser ?? false;
  if (permissions?.permission == null) return true;

  return Boolean(permissions.permission);
};
